import { render, staticRenderFns } from "./HisInformationFixedPhrasesMenu.vue?vue&type=template&id=4450e722&scoped=true&"
import script from "./HisInformationFixedPhrasesMenu.vue?vue&type=script&lang=ts&"
export * from "./HisInformationFixedPhrasesMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HisInformationFixedPhrasesMenu.vue?vue&type=style&index=0&id=4450e722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4450e722",
  null
  
)

export default component.exports